import { render, staticRenderFns } from "./UiControlsFrame.vue?vue&type=template&id=10683f20&scoped=true"
import script from "./UiControlsFrame.vue?vue&type=script&lang=js"
export * from "./UiControlsFrame.vue?vue&type=script&lang=js"
import style0 from "./UiControlsFrame.vue?vue&type=style&index=0&id=10683f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10683f20",
  null
  
)

export default component.exports